import { useAppDispatch } from "../../redux";
import { useTranslation } from "react-i18next";
import {
  fetchCitizensBySearchParams,
  updatePageIndex,
} from "../../redux/reducer/citizensReducer";
import { useSelector } from "react-redux";
import Row from "./Row";
import TableHeader from "./tableHeader";
import Pagination from "../pagination";

const CitizenListTable = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  /**
   * Get state variables from redux store
   */
  const { citizens } = useSelector((state: any) => state);
  const { citizensList, pageIndex, pageTotal } = citizens;

  /**
   * update pagination and refetch on page change
   */
  const setPageIndex = (newpage: any) => {
    dispatch(updatePageIndex(newpage));
    dispatch(fetchCitizensBySearchParams());
  };

  return (
    <div className="container-box mb-3">
      <div className="survey-wrapper-box">
        <div className="col-12 mt-2 mt-2 mb-2 fw-bold">{t("citizen-list")}</div>
        <table className="table">
          <TableHeader />
          <tbody>
            {citizensList.map((citizen: any, key: any) => (
              <Row citizen={citizen} key={key} />
            ))}
          </tbody>
        </table>
        <div className="col-12 mt-2 mb-2">
          <Pagination
            onPageChange={setPageIndex}
            pageIndex={pageIndex}
            pageTotal={pageTotal}
          />
        </div>
      </div>
    </div>
  );
};

export default CitizenListTable;
